module.exports = __webpack_public_path__ + "static/media/carbonara.c0b127ee.jpg";